export const normalizeReleasedPlanning = (response) => ({
  ...response,

  blocks:
    response.blocks?.map((block) => ({
      ...block,

      chapters:
        block.chapters?.map((chapter) => ({
          ...chapter,

          attachments:
            chapter.attachments?.map((item) => {
              const releaseManagement =
                item?.attachment?.releaseManagement;

              const history = releaseManagement?.history ?? [];

              const lastReleasedHistory = [...history]
                .reverse()
                .find(
                  (h) =>
                    h.type === "Channel" &&
                    h.status === "Released"
                );

              return {
                ...item,

                attachment: {
                  ...item.attachment,

                  release:
                    releaseManagement?.channel === true,

                  releaseDate:
                    lastReleasedHistory?.actionDate ?? null,
                },
              };
            }) ?? [],
        })) ?? [],
    })) ?? [],

  materials:
    response.materials?.map((material) => ({
      ...material,

      attachments:
        material.attachments?.map((item) => {
          const releaseManagement =
            item?.releaseManagement;

          const history =
            releaseManagement?.history ?? [];

          const lastReleasedHistory = [...history]
            .reverse()
            .find(
              (h) =>
                h.type === "Channel" &&
                h.status === "Released"
            );

          return {
            ...item,

            release:
              releaseManagement?.channel === true,

            releaseDate:
              lastReleasedHistory?.actionDate ?? null,
          };
        }) ?? [],
    })) ?? [],
});